import { render } from "./NotFound.vue?vue&type=template&id=70c4127a&scoped=true"
const script = {}

import "./NotFound.vue?vue&type=style&index=0&id=70c4127a&scoped=true&lang=css"

import exportComponent from "C:\\Users\\THULIB\\Documents\\GitHub\\Coach-Finder-Vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c4127a"]])

export default __exports__